import { NavParams } from 'ionic-angular/navigation/nav-params';
import { Observable } from 'rxjs/Observable';
import { LicenseManagerService } from './../../shared/licensemanager-service/licensemanager.service';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Component, OnInit, Input } from '@angular/core';
import { SPHLicense, SPHCompany, SPHLoggedInUser, SPHApplication } from '../../shared/shared';
import { LoadingController } from 'ionic-angular/components/loading/loading-controller';

import Rx from 'rxjs/Rx';
import { Loading } from 'ionic-angular/components/loading/loading';
import { AlertController, ToastController } from 'ionic-angular';

@Component({
    selector: 'add-licenses',
    templateUrl: 'add-licenses.component.html'
})

export class AddLicensesComponent {
    private _company: SPHCompany;
    @Input() set company(company: SPHCompany) {
        this._company = company;
    }
    get company(): SPHCompany {
        return this._company;
    }

    private _user: SPHLoggedInUser;
    @Input() set user(user: SPHLoggedInUser) {
        this._user = user;
    }
    get user(): SPHLoggedInUser {
        return this._user;
    }

    private availableApplications: SPHApplication[] = [];
    private newLicenses: SPHLicense[] = [];

    constructor(private viewController: ViewController, private licenseManagerService: LicenseManagerService, private loadingController: LoadingController, navParams: NavParams, private alertController: AlertController, private toastController: ToastController) {
        this.company = navParams.get('company');
        this.user = navParams.get('user');
        this.availableApplications = navParams.get('availableApplications');
        if (this.availableApplications === undefined) {
            this.loadApplications();
        }
    }

    public didTapAbort() {
        this.viewController.dismiss();
    }

    public licenseCountChanged(count: number) {
        if (this.newLicenses.length > count) {
            this.newLicenses = this.newLicenses.slice(0, count);
        } else if (this.newLicenses.length < count) {
            while (this.newLicenses.length < count) {
                this.newLicenses.push(this.newLicenses.length > 0 ? this.copyRelevantAttributes(this.newLicenses[this.newLicenses.length - 1], this.createNewLicense()) : this.createNewLicense());
            }
        }
    }

    public didTapCreateLicenses() {
        if (this.newLicenses.length <= 0) {
            return;
        } else if (this.newLicenses.filter( (l) => l.applications.length <= 0 ).length > 0) {
                const alert = this.alertController.create({
                    title: 'Lizenz enhält keine App.',
                    subTitle: 'Alle Lizenzen müssen mindestens eine App enthalten.',
                    buttons: ['OK']
                  });
                alert.present();
                return;
        }

        const loading = this.loadingController.create();
        loading.present();

        this.newLicenses.forEach ((license) => {
            if (!(license.applications.filter( (e) => e.name === 'eproject' ).length > 0)) {
                license.onlyassigned = true;
                license.extrainfos = false;
            }
        });

        const licenses: SPHLicense[] = [];
        Rx.Observable.concat(...this.newLicenses.map((license) => {
                    return this.licenseManagerService.postLicense(license, this.user.jwt);
                })).subscribe((license) => {
                    licenses.push(license);
                }, this.licenseManagerService.handleHttpError('Eine oder mehrere Lizenzen konnten nicht angelegt werden.'),
                () => {
                    loading.dismiss();
                    if (licenses.length > 0) {
                        const alert = this.alertController.create({
                            title: 'Lizenzen senden?',
                            message: 'Sollen die erstellten Lizenzen versendet werden?',
                            buttons: [
                              {
                                text: 'Nein',
                                role: 'cancel',
                                handler: () => {
                                    this.viewController.dismiss();
                                }
                              },
                              {
                                text: 'Ja',
                                handler: () => {
                                    this.resendLicenesAndIDismiss();
                                }
                              }
                            ]
                          });
                        alert.present();
                    }
                });
            // }
    }

    public createNewLicense(): SPHLicense {
        const license = new SPHLicense();
        license.company_id = this.company.id;
        return license;
    }

    private copyRelevantAttributes(source: SPHLicense, destination: SPHLicense) {
        destination.onlyassigned = source.onlyassigned;
        destination.extrainfos = source.extrainfos;

        destination.applications = source.applications.slice(0);
        return destination;
    }

    private loadApplications() {
        if (this.user !== undefined) {
            this.licenseManagerService.getApplications(this.user.jwt).subscribe((applications) => {
                this.availableApplications = applications;
            }, this.licenseManagerService.handleHttpError('Fehler bei Lizenzen-Abruf'));
        }
    }

    private resendLicenesAndIDismiss(licenses: SPHLicense[] = [])  {
        const loading = this.loadingController.create();
        loading.present();

        let licensesObservable: Observable<SPHLicense[]>;
        if (licenses.length <= 0) {
            licensesObservable = this.licenseManagerService.getLicenses(this.company.id, this.user.jwt);
        } else {
            licensesObservable = Observable.of(licenses);
        }

        licensesObservable.subscribe( (lcs) => {
            this.licenseManagerService.resendLicenses(lcs, this.company.id, this.user.jwt).subscribe( (results) => {
                const toast = this.toastController.create({message: 'Lizenzen gesendet!', duration: 3000});
                toast.present();
                loading.dismiss();
                this.viewController.dismiss();
            }, (error) => {
                this.licenseManagerService.handleHttpError('Fehler beim Senden der Lizenzen!', loading)(error);
                this.viewController.dismiss();
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/features/companyLicenseManagement/addLicensesComponent/add-licenses.component.ts